import { TagIcon } from "@heroicons/react/24/outline"
import BadgesTab from "./BadgesTab"

/**
 * Badges extension (admin side): the labels over the product's pictures
 * (Outlet, "до 4XL") and the day it stops being New. The server half is
 * aldoo-na/store/product/extensions/badges (it computes the New badge).
 */
export const StoreProductExtension = {
  id: "badges",
  label: "Badges",
  description: "Labels over the product's pictures and cards, and New until a date",
  section: {
    component: BadgesTab,
    label: "Badges",
    icon: TagIcon,
    order: 740,
  },
}
